import React, { useEffect, useState } from "react";
import {
  Card,
  Col,
  Form,
  InputGroup,
  Row,
  Table,
  Dropdown,
  Badge,
} from "react-bootstrap";
import { Search } from "react-bootstrap-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsisV,
  faEye,
  faPen,
  faToggleOff,
  faToggleOn,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { CompanyService } from "Services/CompanyService";
import { toast } from "react-toastify";

const SubscriptionList = () => {
  const navigate = useNavigate();

  const [subscriptions, setSubscriptions] = useState<any[]>([]);
  const [search, setSearch] = useState("");
  const [currentPage] = useState(1);
  const [limit] = useState(10);

  const getAllSubscriptions = async () => {
    try {
      const res = await CompanyService.getAllSubscriptions(currentPage, limit);

      if (res.status === 200) {
        const list = res?.data?.data?.result || [];

        const normalizedData = list.map((item: any) => ({
          id: item._id,
          company: item.company?.name,
          companyCode: item.company?.company_code,
          plan: item.plan?.name,
          status: item.status?.toUpperCase(),
          startDate: new Date(item.startDate).toLocaleDateString(),
          expiryDate: new Date(item.expiryDate).toLocaleDateString(),
        }));

        setSubscriptions(normalizedData);
      }
    } catch (error) {
      console.error("Unable to fetch subscriptions", error);
    }
  };
  // UPDATE STATUS

  const updateStatus = async (item: any) => {
    try {
      const newStatus = item.status === "ACTIVE" ? "cancelled" : "active";

      const res = await CompanyService.updateSubscriptionStatus(item.id, {
        status: newStatus,
      });

      if (res.status === 200) {
        toast.success("Subscription status updated successfully ");

        getAllSubscriptions(); 
      }
    } catch (error) {
      toast.error("Unable to update status ");
      console.error(error);
    }
  };

  useEffect(() => {
    getAllSubscriptions();
  }, []);

  return (
    <div className="company-page">
      <Card className="company-card shadow-lg border-0">
        <Card.Body>
          <Row className="mb-4 align-items-center">
            <Col md={4}>
              <h4 className="fw-bold mb-0">Subscription Management</h4>
              <small className="text-muted">Manage all subscriptions</small>
            </Col>

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text className="bg-white">
                  <Search />
                </InputGroup.Text>

                <Form.Control
                  placeholder="Search subscription..."
                  value={search}
                  onChange={(e: any) => setSearch(e.target.value)}
                />
              </InputGroup>
            </Col>
          </Row>

          <div className="table-responsive">
            <Table hover className="align-middle company-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Company Code</th>
                  <th>Company Name</th>
                  <th>Plan</th>
                  <th>Status</th>
                  <th>Start Date</th>
                  <th>Expiry Date</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {subscriptions.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>

                    <td>{item.companyCode}</td>

                    <td className="fw-semibold">{item.company}</td>

                    <td>{item.plan}</td>

                    <td>
                      <Badge
                        className={`px-3 py-2 ${
                          item.status === "ACTIVE"
                            ? "bg-success"
                            : item.status === "CANCELLED"
                              ? "bg-warning"
                              : "bg-danger"
                        }`}
                      >
                        {item.status}
                      </Badge>
                    </td>

                    <td>{item.startDate}</td>

                    <td>{item.expiryDate}</td>

                    <td>
                      <Dropdown align="end">
                        <Dropdown.Toggle variant="light" className="action-btn">
                          <FontAwesomeIcon icon={faEllipsisV} />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() =>
                              navigate(
                                `/admin-dash/subscription/view/${item.id}`,
                              )
                            }
                          >
                            <FontAwesomeIcon
                              icon={faEye}
                              className="me-2 text-secondary"
                            />
                            View Subscription
                          </Dropdown.Item>

                          <Dropdown.Item
                            onClick={() =>
                              navigate(
                                `/admin-dash/subscription/edit/${item.id}`,
                              )
                            }
                          >
                            <FontAwesomeIcon
                              icon={faPen}
                              className="me-2 text-primary"
                            />
                            Edit Subscription
                          </Dropdown.Item>

                          <Dropdown.Item onClick={() => updateStatus(item)}>
                            <FontAwesomeIcon
                              icon={
                                item.status === "ACTIVE"
                                  ? faToggleOff
                                  : faToggleOn
                              }
                              className="me-2 text-warning"
                            />
                            Set{" "}
                            {item.status === "ACTIVE" ? "Cancelled" : "Active"}
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default SubscriptionList;
